import { ConfigProvider, Modal } from 'antd';
import type { ModalProps } from 'antd';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { dmsAntdTheme } from '../../config/antdTheme';

import './actionModals.css';

interface ActionModalShellProps extends Pick<ModalProps, 'afterClose' | 'footer' | 'onCancel' | 'open' | 'title'> {
  children: ReactNode;
  busy?: boolean;
  width?: number | string;
}

/** Shared modal boundary for every user-facing RTU action workflow. */
export const ActionModalShell = ({
  afterClose,
  busy = false,
  children,
  footer,
  onCancel,
  open,
  title,
  width = 620,
}: ActionModalShellProps) => {
  const { i18n, t } = useTranslation();

  return (
    <ConfigProvider direction={i18n.dir()} theme={dmsAntdTheme}>
      <Modal
        afterClose={afterClose}
        cancelButtonProps={{ disabled: busy }}
        centered
        className="dms-action-modal"
        closable={!busy}
        destroyOnHidden
        footer={footer}
        keyboard={!busy}
        maskClosable={!busy}
        okButtonProps={{ disabled: busy }}
        onCancel={onCancel}
        open={open}
        title={title}
        width={width}
        aria-label={typeof title === 'string' ? title : t('actionsModal.title')}
      >
        {children}
      </Modal>
    </ConfigProvider>
  );
};

export default ActionModalShell;
